import styled from "styled-components";

export const BadGiftSpan = styled.span`
    font-family: 'RustonBasicBlack', Helvetica, sans-serif;
    font-weight: 900;
    ::after {
        content: "BAD GIFT";
    }
`